import { useMemo } from 'react';

import { useAuth } from '@/app/providers';

export const useAuthStatus = () => {
    const { isLoggedIn } = useAuth();
    return useMemo(() => ({ isLoggedIn }), [isLoggedIn]);
};
